import React, { useState } from "react";
import Footer from "../components/Footer";
import UserInfoModal from "../components/UserInfoModal";
import MigrationHero from "../components/migrations/MigrationHero";
import MigrationTOC from "../components/migrations/MigrationTOC";
import MigrationWhenSection from "../components/migrations/MigrationWhenSection";
import MigrationWhySection from "../components/migrations/MigrationWhySection";
import MigrationUseCases from "../components/migrations/MigrationUseCases";
import MigrationCTA from "../components/migrations/MigrationCTA";

export default function MigrationInsights() {
  const [openModal, setOpenModal] = useState(false);

  return (
    <main className="bg-primary-dark text-white">
      <MigrationHero />
      <MigrationTOC />

      <div className="px-6 py-16 bg-primary">
        <div className="max-w-6xl mx-auto">
          <MigrationWhenSection />
          <MigrationWhySection />
          <MigrationUseCases />
          <MigrationCTA onOpenModal={() => setOpenModal(true)} />
        </div>
      </div>

      <UserInfoModal isOpen={openModal} onClose={() => setOpenModal(false)} />
      <Footer />
    </main>
  );
}